import { useMemo } from 'react'

import useLDFlags from 'data/hooks/useLDFlags'

import { useRecordSupportsEditing } from './useRecordSupportsEditing'

type UseEditableImageStateProps = {
    type: 'field' | 'image'
    field?: FieldDto
    onChange?: (url?: string, filename?: string) => void
    disabled?: boolean
}

export function useEditableImageState({
    type,
    field,
    onChange,
    disabled,
}: UseEditableImageStateProps) {
    const recordSupportsEditing = useRecordSupportsEditing()
    const { flags } = useLDFlags()
    const isEditable = recordSupportsEditing && flags.detailViewHeaderInlineEditing

    const isFieldTypeEditable = type === 'field' && !!field
    const isImageTypeEditable = type === 'image' && !!onChange
    const effectiveIsEditable =
        isEditable && !disabled && (isFieldTypeEditable || isImageTypeEditable)

    const editableFields = useMemo(() => {
        if (type === 'field' && field) return [field]
        return [] as FieldDto[]
    }, [type, field])

    return { isEditable: effectiveIsEditable, editableFields }
}
